
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site-turu",
      function () {
        return require("private-next-pages/site-turu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site-turu"])
      });
    }
  